import type { GraphPath, NodeId } from '@ipfabric/utils';
import { plainMap } from '@ipfabric/utils/fp/plainMap';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import { selectNodesStableData } from 'components/Graph/model/selectors/selectNodesStableData';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import type { GraphState } from '../../GraphState';

export type NodesByPath = Map<GraphPath, Set<NodeId>>;

export const selectNodesByPath: (s: GraphState) => NodesByPath =
  createScopedSelector(() =>
    createSelector(selectNodesStableData, (nodesData) =>
      Object.values(nodesData).reduce<NodesByPath>((result, node) => {
        plainMap.insertOrUpdateMutable(
          node.parentPath,
          () => new Set([node.id]),
          plainSet.insertMutable(node.id),
        )(result);
        return result;
      }, new Map()),
    ),
  );
